import styled from 'styled-components';
import SVG from 'react-inlinesvg';

export interface SvgIconWrapperProps {
  size: string;
}

export const SvgIconWrapper = styled(SVG)<SvgIconWrapperProps>`
  ${document.documentElement.dir === 'rtl' ? `transform: scaleX(-1);` : ``}
  ${(props) =>
    props.size === 'small'
      ? `
    display: block;
    width: 20px;
    height: 20px;
  `
      : ''};
`;
